import { render, staticRenderFns } from "./WarningText.vue?vue&type=template&id=95d245ec&"
import script from "./WarningText.vue?vue&type=script&lang=js&"
export * from "./WarningText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports